import isArray from './isArray';
import isNullOrUndefined from './isNullOrUndefined';
import isObject from './isObject';
import isPlainObject from './isPlainObject';

type Measurable = { size: number } & { length: number };
function isMeasurable(value: unknown, measurePropertyKey: string): value is Measurable {
  if (!isObject(value)) {
    return false;
  }
  return measurePropertyKey in value;
}

export default function isEmpty(value: unknown): value is Primitive {
  if (isNullOrUndefined(value)) {
    return true;
  }

  if (typeof value === 'string' && value.length === 0) {
    return true;
  }

  if (typeof value === 'function') {
    return false;
  }

  if (isPlainObject(value) && Object.keys(value).length === 0) {
    return true;
  }

  if (isArray(value) && value.length === 0) {
    return true;
  }

  const wrapped = new Object(value);
  return (
    (isMeasurable(wrapped, 'size') && wrapped.size === 0) || (isMeasurable(wrapped, 'length') && wrapped.length === 0)
  );
}
